import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { GroupSelect } from 'ui/indexPages/tables/groupSelect';
import { spacing } from 'ui/theme';
import { button } from 'ui/theme/typography';

export const HeaderButton = styled.button`
  ${button}
  display: flex;
  align-items: center;
  background: none;
  border: none;
  padding: ${spacing.half} 0;
  outline: none;
  text-align: left;

  span {
    display: inline-block;
    margin-right: ${spacing.quarter};
  }
`;

export const StyledGroupSelect = styled(GroupSelect)`
  margin-left: -${pxToRem(9)};
`;

export const TableCell = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-start;
  overflow: hidden;
`;
